// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuItemsList__item","link":"MenuItemsList__link"};